<div class="container">
    <div class="single-column-layout">
        <h1>Import Assessments</h1>

        @if (!isImporting && !userCancelled) {
            <div>
                <div class="mb-3">
                    <label>State:</label>
                    <select [(ngModel)]="payload.stateID" (change)="stateSelected()" class="form-select form-select-sm" style="width: auto;">
                        <option [ngValue]="null" disabled>Select a State</option>
                        @for (state of states; track state) {
                            <option [ngValue]="state.stateID">{{ state.abbr }}</option>
                        }
                    </select>
                </div>
                <div class="mb-3">
                    <label>Assessor:</label>
                    <select [(ngModel)]="payload.assessorID" class="form-select form-select-sm" style="width: auto;" [disabled]="!payload.stateID">
                        <option [ngValue]="null" disabled>Select an Assessor</option>
                        @for (assessor of assessors; track assessor) {
                            <option [ngValue]="assessor.assessorID">{{ assessor.abbr }} {{ assessor.municipalityName }}</option>
                        }
                    </select>
                </div>
                <div class="mb-3">
                    <label>Year:</label>
                    <select [(ngModel)]="payload.annualYear" class="form-select form-select-sm" style="width: auto;">
                        @for (year of years; track year) {
                            <option [value]="year">{{ year }}</option>
                        }
                    </select>
                </div>
                <div class="mb-3">
                    <label>Comment:</label>
                    <textarea class="form-control" style="width: 50%" rows="5" [(ngModel)]="payload.comment"></textarea>
                </div>
                <input type='file' (change)="fileChanged($event)" accept=".txt">
                <button class="ace-btn btn-primary" (click)="startImporting()" style="margin-top: 15px;" [disabled]="!payload.assessorID || !fileLines">
                    Import
                </button>
            </div>
        }

        @if (isImporting) {
            <div class="text-center">
                @if (initIndex < fileLines.length) {
                    <h3 class="repeating-ellipses text-start">Reading File</h3>
                }
                @if (initIndex >= fileLines.length) {
                    <h3 class="text-start">Done</h3>
                }
                <progressbar class="active" [class.progress-striped]="initIndex < fileLines.length" [max]="fileLines.length - 1" [value]="initIndex - 1" type="info"></progressbar>
                <h3>{{ successfulImportCount }} / {{ fileLines.length - 1 }} Parcels Successfully Imported</h3>
                <div style="margin-top: 20px;">
                    @if (initIndex < fileLines.length) {
                        <button class="ace-btn btn-primary btn-danger" (click)="cancelImport()">Cancel</button>
                    }
                    @if (initIndex >= fileLines.length) {
                        <button class="ace-btn btn-primary" (click)="initValues()">OK</button>
                    }
                </div>
            </div>
        }

        @if (userCancelled) {
            <div class="text-center">
                <h3>Cancelling...</h3>
                <ws-ace-loader [hasOverlay]="false" [marginTop]="50" [marginBottom]="0"></ws-ace-loader>
            </div>
        }
    </div>
</div>
